<template>
  <div class="my-planning p-t-30">
    <unavailability-calendar-monthly
      :unavailabilityDateList="unavailabilityDateList"
      :unavailabilityDateScheduled="unavailabilityDateScheduled"
      :editable="editable"
      @update-selected-date="updateSelectedDate"
      @updateDateRange="updateDateRange" />

    <unavailability-table
      v-if="selectedDate"
      :date="selectedDate"
      :unavailabilityDateList="unavailabilityDateListScoped"
      @update-unavailability-date="updateUnavailabilityDate" />

    <!-- <candidate-planning-table
      v-if="unavailabilityDateListScoped && unavailabilityDateListScoped.length > 0"
      :start_at="start_at"
      :end_at="end_at"
      :unavailabilityDates="unavailabilityDatesWithDistinctOffers"
    /> -->
    <unavailability-date-form-popup :selectedDate="selectedDate" :unavailabilityDate="unavailabilityDate" />
  </div>
</template>

<script>
  import moment from 'moment-timezone'
  import { mapGetters, mapActions } from 'vuex'
  import UnavailabilityCalendarMonthly from './UnavailabilityCalendarMonthly'
  import UnavailabilityTable from './UnavailabilityTable'
  import CandidatePlanningTable from '@/components/users/CandidatePlanningTable'
  import UnavailabilityDateFormPopup from './UnavailabilityDateFormPopup'

  export default {
    name: 'UnavailabilityCalendar',
    components: { UnavailabilityCalendarMonthly, UnavailabilityTable, UnavailabilityDateFormPopup, CandidatePlanningTable },
    data() {
      return {
        editable: true,
        selectedDate: null,
        unavailabilityDate: null,
        previous_offer_id: 0,
        start_at: null,
        end_at: null
      }
    },
    computed: {
      ...mapGetters({
        unavailabilityDateList: 'unavailabilityDates/unavailabilityDateList',
        unavailabilityDateScheduled: 'unavailabilityDates/unavailabilityDateScheduled'
      }),
      unavailabilityDateListScoped() {
        return this.unavailabilityDateScheduled["unavailability_dates"] || []
      },
      unavailabilityDatesWithDistinctOffers() {
        if (this.unavailabilityDateListScoped != null) {
          var unavailabilityDateListScoped = this.unavailabilityDateListScoped.filter(unavailabilityDate => this.offerAlreadyDisplayed(unavailabilityDate.offer));
          this.previous_offer_id = 0;
          return unavailabilityDateListScoped;
        }
        return []
      },
    },
    methods: {
      ...mapActions({
        loadListDates: 'unavailabilityDates/loadList',
        loadUnavailabilityDateScheduled: 'unavailabilityDates/loadUnavailabilityDateScheduled'
      }),
      updateSelectedDate(date) {
        this.selectedDate = date
      },
      updateUnavailabilityDate(date) {
        this.unavailabilityDate = date
      },
      offerAlreadyDisplayed(offer) {
        if (offer == null) {
          return true
        }
        if (this.previous_offer_id == offer.id) {
          return false;
        } else {
          this.previous_offer_id = offer.id;
          return true;
        }
      },
      updateDateRange(startAt, endAt) {
        this.start_at = startAt;
        this.end_at = endAt;
      },
    },
    mounted: function(){
      this.loadListDates();
      this.loadUnavailabilityDateScheduled({
        start_date: moment().startOf('month').format(this.$i18n.t('format.date')),
        end_date: moment().endOf('month').format(this.$i18n.t('format.date'))
      })
    }
  }
</script>
<style scoped lang="scss">
  .my-planning {
    max-width: 1200px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/unavailabilityCalendars/UnavailabilityCalendar.vue